exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list_from_LeadRelations-css_3xs {\r\n    position: relative;\r\n    margin: 0 32px;\r\n    padding-bottom: 24px;\r\n    color: #2E3D73;\r\n    list-style: none\r\n}\n.list_from_LeadRelations-css_3xs li {\r\n    margin-top: 6px;\r\n}\n.list_from_LeadRelations-css_3xs h4 {\r\n    font-size: 0.825em;\r\n    font-weight: 400;\r\n    line-height: 1.2;\r\n    position: relative\r\n}\n.list_from_LeadRelations-css_3xs h4 span {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n}\n.list_from_LeadRelations-css_3xs h4 strong {\r\n    font-weight: 700;\r\n    margin-left: 24px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"list": "list_from_LeadRelations-css_3xs"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/routes/sales/Lead/Relations/LeadRelations.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Relations/LeadRelations.css
// module chunks = 0